/** Action type constants for the Azure issue-creation form reducer. */
export const AZURE_FORM_ACTION_TYPES = {
	ORGANIZATION_RESOLVED: 'ORGANIZATION_RESOLVED',
	PROJECT_DATA_LOADED: 'PROJECT_DATA_LOADED',
	PROJECT_SELECTED: 'PROJECT_SELECTED',
	ISSUE_TYPE_SELECTED: 'ISSUE_TYPE_SELECTED',
	ISSUE_DATA_UPDATED: 'ISSUE_DATA_UPDATED',
	FIELD_CHANGED: 'FIELD_CHANGED'
} as const;
